export default "__VITE_ASSET__DLhaJygS__"